var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4C15 4.25587 14.9023 4.51187 14.707 4.70687L6.70703 12.7069C6.5125 12.9031 6.25625 13 6 13C5.74375 13 5.48813 12.9023 5.29313 12.707L1.29313 8.70703C1.09781 8.5125 1 8.25625 1 8C1 7.42875 1.46719 7 2 7C2.25587 7 2.51188 7.09766 2.70688 7.29297L6 10.5875L13.2937 3.29375C13.4875 3.09781 13.7437 3 14 3C14.5344 3 15 3.42813 15 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C21 4.25587 20.9023 4.51187 20.707 4.70687L12.707 12.7069C12.5125 12.9031 12.2562 13 12 13C11.7438 13 11.4881 12.9023 11.2931 12.707L7.29313 8.70703C7.09781 8.5125 7 8.25625 7 8C7 7.42875 7.46719 7 8 7C8.25587 7 8.51188 7.09766 8.70688 7.29297L12 10.5875L19.2937 3.29375C19.4875 3.09781 19.7437 3 20 3C20.5344 3 21 3.42813 21 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTick);
export default __webpack_public_path__ + "static/media/double_tick.acb09d87864a817b1e95648b1c788f25.svg";
export { ForwardRef as ReactComponent };